// app/javascript/controllers/p2p/payment_method_toggle_controller.js
//
// Переключает видимость полей формы в зависимости от выбранного
// типа платёжного инструмента (card / sbp).
//
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cardFields", "sbpFields", "radio"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.radioTargets.find(r => r.checked)?.value || "card"
    const isSbp = selected === "sbp"

    this.cardFieldsTargets.forEach(el => {
      el.classList.toggle("hidden", isSbp)
      el.querySelectorAll("input, select").forEach(input => {
        if (isSbp) {
          input.removeAttribute("required")
          input.value = ""
        }
      })
    })

    this.sbpFieldsTargets.forEach(el => {
      el.classList.toggle("hidden", !isSbp)
      el.querySelectorAll("input, select").forEach(input => {
        if (!isSbp) {
          input.removeAttribute("required")
          input.value = ""
        }
      })
    })
  }
}
